<template>
  <div>
    <wc-section-title title='Snow Tracker'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'snow-tracker-base',
  computed: {
    menu () {
      return [
        {
          title: 'Snow Tracker Dashboard',
          icon: this.$store.state.icons.snowTracker.icon,
          route: { name: 'SnowTrackerDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Snow Tracker Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
